import {
  GET_EMPLOYEE_DETAILS,
  GET_DISCIPLINARY_CASE,
  CREATE_EMPLOYEE,
  GET_EMPLOYEE,
  GET_ALL_CASE,
  GET_INACTIVE_EMPLOYEE,
  GET_WHO_IS_OUT_EMPLOYEE,
} from "../../actionTypes";

const initialState = {
  employee: {},
  jobtitles: [],
  roles: [],
  leaves: [],
  banks: [],
  remaining: [],
  days: [],
  employees: [],
  inActives: [],
  whoIsOut: [],
  disciplinaryCases: [],
  cases: [],
};

export const employeeMngtReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_EMPLOYEE_DETAILS:
      return {
        ...state,
        employees: payload.data,
      };

    case GET_INACTIVE_EMPLOYEE:
      return {
        ...state,
        inActives: payload.data,
      };

    case GET_WHO_IS_OUT_EMPLOYEE:
      return {
        ...state,
        whoIsOut: payload.data,
      };

    case GET_DISCIPLINARY_CASE:
      return {
        ...state,
        disciplinaryCases: payload.data,
      };

    case CREATE_EMPLOYEE:
      return {
        ...state,
        employees: payload,
      };
    case GET_EMPLOYEE:
      return {
        ...state,
        employee: payload.employee,
        jobtitles: payload.jobtitles,
        roles: payload.roles,
        leaves: payload.leaves,
        banks: payload.banks,
        remaining: payload.remaining,
        days: payload.days,
      };

    case GET_ALL_CASE:
      return {
        ...state,
        cases: payload.cases,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/actions/employeemanagement/employee.reducers.js